import currency from 'currency.js';

const roundValue = (value: number, currencyPrecision: number): number =>
    currency(value, { symbol: '', precision: currencyPrecision }).value;

export default roundValue;
